import React from 'react';

const PercentageMeters = ({ resolvedPercentage, pendingPercentage }) => {
  const data = [
    { label: 'Resolved Requests', percentage: resolvedPercentage },
    { label: 'Pending Requests', percentage: pendingPercentage },
  ];

  return (
    <div className="mx-auto pt-5">
      <div className="grid gap-6 sm:grid-cols-1 lg:grid-cols-2">
        {data.map((item, index) => (
          <div
            key={index}
            className="flex flex-row items-center justify-between bg-white p-6 rounded-2xl shadow-sm"
          >
            <div className="flex flex-col justify-center w-full">
              <p className="text-lg text-navy-700 tracking-wider font-bold mb-2">{item.label}</p>
              <div className="w-full bg-gray-300 rounded-full h-6">
                <div 
                  className="bg-[#c51369] h-6 rounded-full text-center tracking-wide text-white font-bold" 
                  style={{ width: `${item.percentage}%` }}
                >
                  {item.percentage.toFixed(2)}%
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PercentageMeters;











// import React from 'react';

// const PercentageMeters = () => {
//   const data = [
//     { label: 'Resolved Requests', percentage: 58 },
//     { label: 'Pending Requests', percentage: 42 },
//   ];

//   return (
//     <div className="mx-auto pt-5">
//       <div className="grid gap-6 sm:grid-cols-1 lg:grid-cols-2">
//         {data.map((item, index) => (
//           <div
//             key={index}
//             className="flex flex-row items-center justify-between bg-white p-6 rounded-2xl shadow-sm"
//           >
//             <div className="flex flex-col justify-center w-full">
//               <p className="text-lg text-navy-700 tracking-wider font-bold mb-2">{item.label}</p>
//               <div className="w-full bg-gray-300 rounded-full h-6">
//                 <div 
//                   className="bg-[#c51369] h-6 rounded-full text-center tracking-wide text-white font-bold" 
//                   style={{ width: `${item.percentage}%` }}
//                 >
//                   {item.percentage}%
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default PercentageMeters;
